import { render, staticRenderFns } from "./ModalR1.vue?vue&type=template&id=431cc442&"
import script from "./ModalR1.vue?vue&type=script&lang=js&"
export * from "./ModalR1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports